import React, {SVGProps} from 'react';
const filterApp = (props: SVGProps<SVGSVGElement>): JSX.Element => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 32" {...props}>
		<path d="M14 24h5.333v-2.667H14zM4.667 8v2.667h24V8zm4 9.333h16v-2.667h-16z" />
	</svg>
);
export default filterApp;
